import { render, staticRenderFns } from "./superBOrderDetails.vue?vue&type=template&id=2fb65c20&"
import script from "./superBOrderDetails.vue?vue&type=script&lang=js&"
export * from "./superBOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./superBOrderDetails.vue?vue&type=style&index=0&id=2fb65c20&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports